/**
 * @generated SignedSource<<bf8c73e6c2fbdc45d697f7b0243d2f6e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AssetTokenStandard = "AUCTION_HOUSE" | "BITKEEP" | "BLUR" | "CONSIDERATION" | "CRYPTOKITTIES" | "CRYPTOPUNKS" | "CUSTOM" | "DECENTRALAND" | "ELEMENT" | "ENJIN_LEGACY" | "ERC1155" | "ERC20" | "ERC721" | "ETH_BRIDGE" | "JOEPEGS" | "KNOWNORIGIN" | "LOOKSRARE" | "MAKERSPLACE" | "METAPLEX" | "SEADROP" | "SOLANA" | "SPL" | "SUPERRARE" | "TOFU" | "TRANSFER_HELPER" | "TROVE" | "UNKNOWN" | "WYVERN" | "X2Y2" | "ZERO_EX" | "%future added value";
export type TransactionTypeEnum = "ACCEPT_OFFER" | "ACCEPT_SWAP" | "APPROVE_COLLECTION" | "ASSETS_RECEIVED" | "ASSETS_SENT" | "BRIDGE_DEPOSIT" | "BRIDGE_WITHDRAW" | "BULK_ACCEPT_OFFER" | "BULK_OFFER_ACCEPTED" | "BULK_PURCHASE" | "BULK_RECEIVED" | "BULK_SALE" | "BULK_SENT" | "BUY_NOW" | "CANCEL_ALL_ORDERS" | "CANCEL_ASK" | "CANCEL_BID" | "CANCEL_COLLECTION_OFFFER" | "CANCEL_ORDERS" | "CANCEL_SWAP" | "CONFIGURE_DROP" | "CREATE_SEADROP_CONTRACT" | "ERC20_APPROVE" | "ERC20_RECEIVED" | "ERC20_SENT" | "ERC20_SWAP_DEPOSIT" | "ERC20_SWAP_WITHDRAW" | "MINT" | "MINT_ALLOWLIST" | "NATIVE_RECEIVED" | "NATIVE_SENT" | "NFT_RECEIVED" | "NFT_SENT" | "OFFER_ACCEPTED" | "OPENSEA_PRO_TRADE" | "REDEEM" | "SALE" | "SWAP_COMPLETE" | "UNKNOWN" | "UNWRAP" | "WRAP" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type DealAccept_metadata$data = {
  readonly receivedAssetQuantities: ReadonlyArray<{
    readonly asset: {
      readonly decimals: number | null | undefined;
      readonly tokenStandard: AssetTokenStandard | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"StackedAssetMedia_assets">;
    };
    readonly quantity: string;
  }>;
  readonly sentAssetQuantities: ReadonlyArray<{
    readonly asset: {
      readonly decimals: number | null | undefined;
      readonly tokenStandard: AssetTokenStandard | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"StackedAssetMedia_assets">;
    };
    readonly quantity: string;
  }>;
  readonly type: TransactionTypeEnum;
  readonly " $fragmentType": "DealAccept_metadata";
};
export type DealAccept_metadata$key = {
  readonly " $data"?: DealAccept_metadata$data;
  readonly " $fragmentSpreads": FragmentRefs<"DealAccept_metadata">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AssetType",
    "kind": "LinkedField",
    "name": "asset",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tokenStandard",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "decimals",
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "StackedAssetMedia_assets"
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "quantity",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DealAccept_metadata",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AssetQuantityType",
      "kind": "LinkedField",
      "name": "sentAssetQuantities",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AssetQuantityType",
      "kind": "LinkedField",
      "name": "receivedAssetQuantities",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "TransactionMetadataType",
  "abstractKey": null
};
})();

(node as any).hash = "64d3b4701c42f850f0a2413e0b89796d";

export default node;
